import { render, staticRenderFns } from "./UiShowDiscounts.vue?vue&type=template&id=20541714&lang=pug&"
import script from "./UiShowDiscounts.vue?vue&type=script&lang=js&"
export * from "./UiShowDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports